<template>
   <div>
      <div v-if="quiz" style="margin: 25px 0 25px 0">
         <h2 v-if="title != ''">{{title}}</h2>
         <i v-if="record && !warnoff" style="color:red;">Ved å besvare denne testen aksepterer du at svar og tidspunkt lagres anonymt for statistiske formål.</i>
         <span v-if="rating && showscore" style="font-weight:bold;">
            <div style="margin-top:30px;" v-html="verdict"></div>
            <p>
              Du klarte {{score}}%
            </p>
            <p style="margin-top:20px;margin-bottom:50px;">
               Du kan prøve ut andre svar nedenfor
            </p>
         </span>
      </div>
      <div v-else>&nbsp;</div>
	 <div v-if="bnr < blocks.length">
         <div v-if="(!quiz) && (blocks[bnr].intro != '')" v-html="blocks[bnr].intro" style="padding-bottom: 10px; margin:0 0 20px 0;border-bottom:1px solid #f0f0f0;"></div> 
         <div v-for="spm in blocks[bnr].questions" :key="spm.id">
            <div v-if="(qlist.length == 0) || (qlist.indexOf(spm.qname) != -1)" style="margin-bottom:20px;">
               <div style="margin-bottom:10px;" v-html="rmtextid(spm.text)"></div>
               <essay v-if="spm.type == 'ESSAY'" :essayfeedback="essayfeedback" :enbloc="enbloc" :thisq="spm"></essay>
	       <sab v-else-if="spm.type == 'SAB'" :thisq="spm"></sab>
               <dragdrop v-else-if="spm.type == 'HOT'" :thisq="spm"></dragdrop>
               <mcq v-else :thisq="spm" :tryonce="tryonce" :record="record" :enbloc="enbloc" :showscore="showscore" :token="kvittering"></mcq>
               <hr v-if="separator">
            </div>
         </div>
         <div v-if="quiz && (testtype == 'survey')" style="margin-top:30px;">
            <button type="button" style="margin-right:30px;" v-on:click="submitsurvey">
              Fortsett
            </button>
         </div>
         <div v-else-if="quiz" style="margin-top:30px;">
            <button type="button" v-if="enbloc" style="margin-right:30px;" :disabled="!enablecheck" v-on:click="makecheck">
              <span v-if="rating">Score meg!</span><span v-else>Sjekk svarene</span>
            </button>
            <button v-if="repeat" type="button" onclick="loadtest(callparam);">Ny test</button>
         </div>
         <div v-else-if="!quiz" style="margin-top:30px;">
	       <div v-if="bnr < blocks.length">
               <button type="button" :disabled="bnr == 0" v-on:click.prevent="bnr--">Tilbake</button>
               &nbsp;&nbsp;
               <button type="button" v-on:click.prevent="bnr++">Fortsett</button>
            </div>
         </div>
      </div>
      <div v-else-if="!quiz">
         <div style="margin-bottom:15px;" v-html="messages"></div>
         <span class="goodbye">Den virtuelle pasienten er ferdig.<p><b>Takk for nå!</b></p></span>
      </div>
   </div>
</template>


<script>

   var testdata;
   var request = new XMLHttpRequest();
   request.open('GET', 'https://studmed.uio.no/vp/' + query, false);  // `false` makes the request synchronous
   request.send(null);
   if (request.status === 200) {
     testdata = JSON.parse(request.responseText.replace(/\\'/g,"'").replace(/\\\\"/g,'\\"'));
   }
   else {
     //Error(httpreq.statusText));
   }
   
   var tekster = {
     'no' : {
         'personvern': 'Ved å besvare denne testen aksepterer du at svar og tidspunkt lagres anonymt for statistiske formål.',
         'utforsk': 'Du kan prøve ut andre svar nedenfor',
         'sjekk': 'Sjekk svarene',
         'nytest': 'Ny test',
         'tilbake': 'Tilbake',
         'fortsett': 'Fortsett',   
         'ferdig': 'Den virtuelle pasienten er ferdig.<p><b>Takk for nå!</b></p>',
         'riktig': 'Riktig. ',
         'galt': 'Galt. ',
         'ingenforklaring': 'Det er ingen forklaringer til de gale svarene',
         'nyttig': 'Nyttig å vite om de gale svarene:'
         },
     'en': {	     
         'personvern': 'By answering this test you accept that answers and date and time are stored anonymously for statistical purposes.',
         'utforsk': 'You can try out other answers below',
         'sjekk': 'Check answers',
         'nytest': 'New test',
         'tilbake': 'Back',
         'fortsett': 'Continue',   
         'ferdig': 'The virtual patient is complete.<p><b>Good bye!</b></p>',
         'riktig': 'Correct. ',
         'galt': 'Incorrect. ',
         'ingenforklaring': 'There are no explanations to the incorrect answers',
         'nyttig': 'Nice to know about the incorrect answers:'
         }
   };


import ajaxmixin from './ajaxmixin.vue'
   import essay from './essay.vue'
   import mcq from './mcq.vue'
   import sab from './sab.vue'
   import dragdrop from './dragdrop.vue'

   export default {
      name: 'formativetest',
      mixins: [ajaxmixin],
   
      components: {
         essay,
         mcq,
	 sab,
         dragdrop
      },
	       
      props: {
        query: {
           type: String,
           default: ''
        },
        qnames: {
           type: String,
           default: ''
        },
        warnoff: {
           type: Boolean,
           default: false
        }
      },

      data: function() {
         if (!testdata.hasOwnProperty('prepared')) {
            var fb = "";
            var nofb = true;
            testdata.bnr = 0;
            testdata.url = window.location.href;
            testdata.score = 0;
            testdata.verdict = "";
            testdata.showscore = false;
            if (testdata.rating) {
               testdata.enbloc = true;
            }
            if (testdata.separator == undefined) {
               testdata.separator = true;
            }
            if (testdata.essayfeedback == undefined) {
               testdata.essayfeedback = false;
            }
            if (testdata.language == undefined) {
               testdata.language = 'no';
            }
            for (let blk in testdata.blocks) {
               for (let qid in testdata.blocks[blk].questions) {
                  let question = testdata.blocks[blk].questions[qid];
                  question.id = [('0000000' + question.question_mid).slice(-8), ('0000000' + question.question_lid).slice(-8), question.revision].join('_');
                  question.tainted = false;
      	          if (!['ESSAY','HOT'].includes(question.type)) {
                     question.choices = [];
                     question.selected = (['SEL','MAT','SAB'].includes(question.type) ? null : []); 
      	             nofb = true;
                     fb = "";
                     for (let i in question.qml) {
                        let tmp = question.qml[i][1];
                        if (['SEL','MAT','SAB'].includes(question.type)) {
      		            for (let j in tmp.alternatives) {
      	                       tmp.alternatives[j].feedback.replace(/^(feil|galt)[\.\!]?\ ?/i,"");
                               tmp.alternatives[j].feedback = (tmp.alternatives[j].correct ? tekster[testdata.language].riktig : tekster[testdata.language].galt) + ' ' + tmp.alternatives[j].feedback;
      	                    }
                         }
      	                 else {
      	                    tmp.feedback.replace(/^(feil|galt)[\.\!]?\ ?/i,"");
           	            if ((question.type == 'MC') && (!tmp.correct)) {
      		               if (tmp.feedback != '') {
      		                  nofb = false;
                               }
      	                       fb += "<br>" + ((tmp.feedback.length == 0) ? '-' : tmp.feedback);
                            }
                            tmp.feedback = (tmp.correct ? tekster[testdata.language].riktig : tekster[testdata.language].galt) + ' ' + tmp.feedback;
                         }
                         tmp.id = [question.id, question.qml[i][0]].join('_');
                         tmp.checked = false;
                         question.choices.push(tmp);
      	             }
        	     if (!testdata.oneline && (question.type == 'MC')) {
                        if (nofb) {
      	                   fb = '<p><i>(' + tekster[testdata.language].ingenforklaring + ')</i></p>';
                        }
      	                else {
                           fb = '<p><i>' +  tekster[testdata.language].nyttig + '</i>' + fb + '</p>'
                        }
                        for (let i in question.choices) {
           	           if (question.choices[i].correct) {
      	                      question.choices[i].feedback += fb;
      	                   }
                        }
                     }
                  }
                  question.qml = null;
               }
            }
            testdata.prepared = true;
	    return(testdata)
	 }
      },


      beforeCreate: function() {
         if (navigator.userAgent.search("MSIE") >= 0) {
            alert("Dette programmet virker ikke med Internet Explorer. Bruk Chrome, Edge, Firefox, Opera eller Safari.\n\nThis program does not work with Internet Explorer. Use Chrome, Edge, Firefox, Opera or Safari.");
         }
      },
   
      created: function() {
        this.qlist = (this.qnames == '' ? [] : this.qnames.split(','));
      },
   
      mounted: function() {
         window.scrollTo(0,0);
      },
   
      computed: {
         enablecheck: function() {
         let r = true;
   	 let qblk = this.blocks[this.bnr].questions;
   	 for(let i in qblk) {
               if (!qblk[i].tainted) {
                  r = false;
                  break;
               }
            }
            return r;
         }
      },
   
   
      methods: {
         makecheck: function() {
            if (this.rating) {
               var sum=0.0;
   	       var maxs = 0.0;
               var qsum = 0.0;
               var qpcondition = [];
               var qblk = this.blocks[this.bnr].questions;
               for (let iq in qblk) {
                  let q = qblk[iq];
                  qpcondition.length = q.choices.length;
                  qpcondition.fill(false);
                  for (let i in q.selected) {
                     qpcondition[q.selected[i]] = true;
                  }
                  maxs = 0.0;
                  qsum = 0.0;
                  for (let cid in q.tests) {
                     let c = q.tests[cid];
                     maxs += c.score;
   		     if (eval(c.test)) {
                        qsum += c.score;
   		     }     
                  }
                  sum += qsum/maxs;  
               }
               sum = Math.round(sum * 100.0 / qblk.length);
   	       let limits = Object.keys(this.messages);
   	       let mylim = "101";
   	       for(let i=limits.length-1;i>=0;i--) {
                  if (sum < parseInt(limits[i])) {
                     mylim = limits[i];
                  }
               }
               this.score = sum;
   	    this.verdict = this.messages[mylim];
            }
            this.enbloc = false;
   	    this.showscore = true;
         },
	 
         submitsurvey: function() {
            var answers = {};
            var qblk = this.blocks[this.bnr].questions;
            for (let iq in qblk) {
               let q = qblk[iq];
   	       if (q.type == 'ESSAY') {
                  answers[q.id] = q.qml
               } else {
                  answers[q.id] = q.selected.join('_')
               }
            }
            var survey = {
               surveyid: this.surveyid,
               testtopic: this.testtopic,
               answers: answers
            }
            this.ajaxtalk(survey, this.registrar, 'POST', this.loadnext, this.kvittering);
         },
	 
         loadnext: function(jsonpar) {
            let param = JSON.parse(jsonpar);
            window.surveyid = param.surveyid;      
            loadtest('quiztopic=' + param.testtopic + '&explode=1');
         },
	 
         rmtextid: function(txt) {
            return(txt.replace(/^\d+\.\d+\.\d+\ ?/,''));
         } 
      }
   }
</script>

<style>
   .goodbye {
      margin-top: 35px;
   }

</style>
